import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { createFilterOptions } from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import { ReactNode } from 'react'

// Something that can be selected in an Select field, aka. option
// Note: this type is used all over the app, so the optional color field will
// be accessible to any component that needs it.
export type Selectable = {
  id: string
  name: string
  color?: string
  textColor?: string
  backgroundColor?: string
  isDisabled?: boolean
  tooltipValue?: string
  description?: string
  startIcon?: ReactNode
  endIcon?: ReactNode
}

export type Selection = Selectable | Selectable[] | null

const icon = <CheckBoxOutlineBlankIcon />
const checkedIcon = <CheckBoxIcon />
export const SelectionCheckbox = ({ selected }: { selected: boolean }) => {
  return (
    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
  )
}

// values are equal if their IDs are equal
export const selectableComparer = (opt: Selectable, value: Selectable) => opt.id === value.id

// Client-side text searching for select options
export const selectableFilterOptions = createFilterOptions({
  matchFrom: 'any',
  ignoreAccents: true,
  ignoreCase: true,
  trim: true,
  stringify: (opt: Selectable) => opt.name,
})
